import React, {useCallback, useState} from "react";
import {AdvancedMarker, InfoWindow, useAdvancedMarkerRef} from "@vis.gl/react-google-maps";
import mapMarkerIcon from "../../images/mapmarker.png";

interface MarkerWithInfoWindowProps {
    position: google.maps.LatLngLiteral;
    infoWindowContent: React.ReactNode;
}

const MarkerWithInfoWindow: React.FC<MarkerWithInfoWindowProps> = (props) => {
    // `markerRef` and `marker` are needed to establish the connection between
    // the marker and infowindow (if you're using the Marker component, you
    // can use the `useMarkerRef` hook instead).
    const [markerRef, marker] = useAdvancedMarkerRef();

    const [infoWindowShown, setInfoWindowShown] = useState(false);

    // clicking the marker will toggle the infowindow
    const handleMarkerClick = useCallback(
        () => setInfoWindowShown(isShown => !isShown),
        []
    );

    // if the maps api closes the infowindow, we have to synchronize our state
    const handleClose = useCallback(() => setInfoWindowShown(false), []);

    return (
        <>
            <AdvancedMarker
                ref={markerRef}
                position={props.position}
                onClick={handleMarkerClick}
            >
                <img src={mapMarkerIcon} alt="Map Marker"/>
            </AdvancedMarker>

            {infoWindowShown && (
                <InfoWindow anchor={marker} onClose={handleClose}>
                    {props.infoWindowContent}
                </InfoWindow>
            )}
        </>
    );
};

export default MarkerWithInfoWindow;